import { render, staticRenderFns } from "./DueDayRule.vue?vue&type=template&id=627beb4e&"
import script from "./DueDayRule.vue?vue&type=script&lang=js&"
export * from "./DueDayRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports